/** @format */

export default function useQuery(): URLSearchParams {
  return new URLSearchParams(window.location.search);
}
